module.exports = "http://cdn.realive.com.ua/src/views/player/menu/elements/fractions/elements/tasks/images/2.png";